import { Box } from "@braintrust/braintrust-ui-components";
import { PublicTopNavigation } from "@js/components/public-top-navigation";
import { AppLayout } from "@js/layouts/app";

import type { PublicJobsProps } from "../components";
import {
  PublicJobs,
  PublicJobsListingClientsCarousel,
  PublicJobsListingHeader,
} from "../components";

import styles from "./public-listing.module.scss";

type PublicJobsListingPageProps = PublicJobsProps;

export const PublicJobsListingPage = (props: PublicJobsListingPageProps) => {
  return (
    <AppLayout
      pageTitle="Jobs"
      bgcolor={`var(--soft-blue)`}
      renderOverwriteNavigationComponent={() => <PublicTopNavigation />}
      className={styles.publicJobsPage}
    >
      <Box sx={{ width: "100%" }}>
        <PublicJobsListingHeader />
        <PublicJobsListingClientsCarousel />
        <PublicJobs {...props} />
      </Box>
    </AppLayout>
  );
};
